import Axios from 'axios'
import { Cookies } from 'react-cookie'
import { Method, ServicePath } from '../utils';
var CryptoJS = require("crypto-js");

export const Request = (method, path, data) => {
    const cookies = new Cookies()
    const token = cookies.get('user')
    var tokentext = ''
    // Decrypt
    if (token !== null && token !== undefined) {
        var bytes = CryptoJS.AES.decrypt(token, process.env.REACT_APP_HASH_KEY);
        tokentext = bytes.toString(CryptoJS.enc.Utf8);
    }  
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + (tokentext === '' ? '' : JSON.parse(tokentext))
    }

    return new Promise((resolve, reject) => {
        Axios({
            method: method,
            // url: `https://beverestlifeauthenapiuat.thaibevapp.com${path}`,
            url: `${process.env.REACT_APP_API_URL}${path}`,
            headers: headers,
            data: data
        }).then(function (response) {
            if (response.status === 200) {
                resolve(response.data)
            }else if(response.status === 401){

            }
            else {
                return reject(Error(response.data.msg))
            }
        }).catch(function (error) {
            reject(error)
        })
    })
}

export const reqAppList=()=>{
    return Request(Method.GET, ServicePath.AppList, {}).then( res=>{
        return res
    }).catch(err=>{
        console.log(err)
        return err
    })
}

export const reqPermissions=()=>{
    return Request(Method.GET, ServicePath.PermissionList, {}).then( res=>{
        return res
    }).catch(err=>{
        return err
    })
}
export const createRole =(data)=>{
    return Request(Method.POST, ServicePath.GroupCreate,data).then( res=>{
        return res
    }).catch(err=>{
        return err
    })
}
export const reqRoles=()=>{
    return Request(Method.GET, ServicePath.GroupList, {}).then( res=>{
        return res
    }).catch(err=>{
        console.log(err)
        return err
    })
}
export const reqRoleById=(id)=>{
    return Request(Method.GET, ServicePath.GroupById+`/${id}`, {}).then( res=>{
        return res
    }).catch(err=>{
        console.log(err)
        return err
    })
}
export const reqUserGroup=(empid)=>{
    return Request(Method.GET, ServicePath.GroupList+`/${empid}`, {}).then( res=>{
        return res
    }).catch(err=>{
        console.log(err)
        return err
    })
}

export const reqAddUserToGroup=(data)=>{
    return Request(Method.PUT, ServicePath.AddUserToGroup, data).then( res=>{
        return res
    }).catch(err=>{
        console.log(err)
        return err
    })
}

export const reqAddAppToGroup=(data)=>{
    return Request(Method.PUT, ServicePath.AddAppToGroup, data).then( res=>{
        return res
    }).catch(err=>{
        console.log(err)
        return err
    })
}

export const deleteUserGroup=(data)=>{
    return Request(Method.PUT, ServicePath.DeleteUserInGroup, data).then( res=>{
        return res
    }).catch(err=>{
        console.log(err)
        return err
    })
}

export const deleteAppGroup=(data)=>{
    return Request(Method.PUT, ServicePath.DeleteAppInGroup, data).then( res=>{
        return res
    }).catch(err=>{
        console.log(err)
        return err
    })
}

export const deleteGroup=(data)=>{
    return Request(Method.DELETE, `${ServicePath.DeleteGroup}/${data}`, {}).then( res=>{
        return res
    }).catch(err=>{
        console.log(err)
        return err
    })
}
export const deleteUser = (data) => {
    return Request(Method.DELETE, `${ServicePath.DeleteUser}/${data}`, {}).then(res => {
        return res
    }).catch(err => {
        console.log(err)
        return err
    })
}
// export const authSign =()=>{
//     const data = {
//         "work":"AUTH_SIGN",
//         "app_key": "ElbGQNRz20Sgqf0RkHoo1A8htVTZh6shrIwDlbYz8HqJ5fYJLavPagRNaIkkASR6vnoQBQd42M6x3okp"
//     }
//     return requestNoti(data).then( res=>{
//         return res
//     }).catch(err=>{
//         return err
//     })
// }